import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

export const log = {
  omicronFromLandingToVitrina: () => {
    logTmrEvent(EVENTS.omicronFromLandingToVitrina);
  },

  omicronFromLandingToInstructions: () => {
    logTmrEvent(EVENTS.omicronFromLandingToInstructions);
  },

  landingDownloadRustoreMainClick: () => {
    logTmrEvent(EVENTS.landingDownloadRustoreMainClick);
  },
};
